import { AppState } from 'src/reducers';
import { SupportedChatChannel } from 'src/chats/supportedChatChannel';
import { selectSelectedChatClient } from 'src/reducers/chats/clients';
import { ChatConversationId, ChatMessage } from 'src/types/chatMessage';

const INBOX_ROUTE_PREFIX = '/smschat';

export const toConversationId = (message: Pick<ChatMessage, 'channel' | 'senderId' | 'clientId'>): ChatConversationId => ({
  channel: message.channel,
  senderId: String(message.senderId),
  clientId: String(message.clientId),
});

export const resolveMessageForCurrentConversation = (state: AppState, chatMessage: ChatMessage) => {
  const rawConversationId = toConversationId(chatMessage);
  const selectedChatClient = selectSelectedChatClient(state, chatMessage.channel);
  const pathname = state.router?.location?.pathname ?? '';
  const isInboxRouteActive = pathname.startsWith(INBOX_ROUTE_PREFIX);
  const isSelectedClientMatch = selectedChatClient?.id === rawConversationId.clientId;
  const isWhatsAppSenderAliasCase =
    chatMessage.channel === SupportedChatChannel.WHATSAPP && isInboxRouteActive && Boolean(isSelectedClientMatch);

  // WhatsApp can deliver incoming senderId in an alias form while UI conversation is
  // scoped by selected sender for the same client. Rebind only for active inbox chat.
  const normalizedMessage =
    isWhatsAppSenderAliasCase && selectedChatClient
      ? { ...chatMessage, senderId: String(selectedChatClient.senderId) }
      : chatMessage;

  const normalizedConversationId = toConversationId(normalizedMessage);
  const isOpenConversationByUser =
    isInboxRouteActive &&
    selectedChatClient?.id === normalizedConversationId.clientId &&
    selectedChatClient?.senderId === normalizedConversationId.senderId;

  return {
    normalizedMessage,
    rawConversationId,
    normalizedConversationId,
    isOpenConversationByUser,
  };
};
